import { render, staticRenderFns } from "./markethangtag.vue?vue&type=template&id=1a85d346&scoped=true"
import script from "./markethangtag.vue?vue&type=script&lang=js"
export * from "./markethangtag.vue?vue&type=script&lang=js"
import style0 from "./markethangtag.vue?vue&type=style&index=0&id=1a85d346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85d346",
  null
  
)

export default component.exports